import { Avatar, Card, Typography } from "@mui/material";
import React from "react";
function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}
export const AvatarProfilePic = ({ firstName, profilePicture }) => {
  return (
    <>
      <Card
        sx={{
          display: "flex",
          alignItems: "center",
          padding: 0,
          border: 0,
          boxShadow: 0,
          background: 0,
          margin: 0,
        }}
      >
        <Avatar
          alt={firstName}
          src={profilePicture}
          sx={{
            width: 55,
            height: 55,
            marginRight: 2,
            background: stringToColor(firstName),
          }}
        />
        <Typography variant="h6" component="div">
          {firstName}
        </Typography>
      </Card>
    </>
  );
};
